const isValidEmail = (input) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return regex.test(input)
}

const hasError = (input) => {
  return input.closest('.form-field').querySelector('.field-validation-error')
}

const showError = (input, message) => {
  const errorMsg = document.createElement('div')
  errorMsg.classList.add('field-validation-error')
  errorMsg.innerText = message
  input.closest('.form-field').append(errorMsg)
}

export function checkRecaptcha() {
  const recaptchaResponse = document.getElementById('g-recaptcha-response')
  let recaptchaResponseValue = ''
  if (recaptchaResponse) {
    recaptchaResponseValue = recaptchaResponse.value
  }
  if (recaptchaResponseValue === '') {
    return false
  }
  return true
}

export function checkFields(inputs, map) {
  let isValid = true

  // Check shared fields
  const emailHasError = hasError(inputs.email)
  if (emailHasError) {
    emailHasError.remove()
  }
  if (!isValidEmail(inputs.email?.value)) {
    showError(inputs.email, 'Please enter a valid email address before submitting')
    isValid = false
  }

  // Check Subscription form fields
  if (map === 'subscribe') {
    const [firstInput, allInputs] = inputs.signup
    const checkboxHasError = hasError(firstInput)
    if (checkboxHasError) {
      checkboxHasError.remove()
    }

    if (allInputs.length === 0) {
      showError(firstInput, 'Please select at least one publication to sign up for')
      isValid = false
    }
  }

  return isValid
}